import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "switcher-contrast" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      onClick: _ctx.handleContrastClick,
      icon: "mdi mdi-brightness-6",
      variant: "text",
      title: "Zmień kontrast"
    }, null, 8, ["onClick"])
  ]))
}